import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, SubmissionError, propTypes as formProps } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';

import { TextInput, scrollToFirstError, generateValidation } from 'ecs-react-components/dist/index.es';
import validations from './ResetPasswordForm.validations';
import { messages } from './ResetPasswordForm.i18n';

const fields = ['username'];

class ResetPasswordForm extends Component {
  onResetPasswordClick = (values) => {
    if (values.username) {
      this.props.handleResetPassword(values.username, this.props.language);
    } else {
      throw new SubmissionError({ username: 'required' });
    }
  }

  getUserNameTextInputRef = (c) => { this.userNameTextInputRef = c; };

  renderField = (userNameField) => {
    const { input, meta: { error } } = userNameField;
    return (
      <div className="mb-3">
        <label className="form-label" htmlFor={input.name}>
          <FormattedMessage {...messages.usernameTitle.label} />
        </label>
        <TextInput
          ref={this.getUserNameTextInputRef}
          field={ userNameField }
        />
        {
          error &&
          <span className="invalid-feedback"><FormattedMessage {...messages.required.error} /></span>
        }
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit(this.onResetPasswordClick)}>
            <div className="row justify-content-md-center mt-3">
              <div className="col-md-auto">
                <div className="card p-3" >
                  <div className="card-body">
                    <h5 className="card-title" id="content">
                      <FormattedMessage {...messages.pageTitle.label} />
                    </h5>
                    <p className="card-text">
                    <FormattedMessage {...messages.intro.label} />
                    </p>
                    <Field name="username" component={this.renderField} />
                    <Button type="submit">
                        <FormattedMessage {...messages.resetPassword.label} />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
      </form>
    );
  }
}

ResetPasswordForm.propTypes = {
  handleResetPassword: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  ...formProps,
  language: PropTypes.string,
};

const reduxFormConfig = {
  form: 'resetpasswordform',
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
  ...generateValidation(validations),
};

export default reduxForm(reduxFormConfig)(ResetPasswordForm);
